// eslint-disable-next-line no-restricted-imports -- this is one case where it's ok to import `useSelector` from `react-redux`
import { type TypedUseSelectorHook, useSelector } from 'react-redux';

import type { RootState } from '@app/types';

export default useSelector as TypedUseSelectorHook<RootState>;
